// extracted by mini-css-extract-plugin
export default {"root":"by-params-search_root__q4bnO","action":"by-params-search_action__tFpLd"};